define('components/GDPR',[
    "jquery",
    "logging",
    "location",
    "utilities"
], function ($, logging, location, utilities) {
    var _ModuleName = "GDPR";

    var _config = {
        enabled: true,
        dataattr: "path-gdpr",
        testing: {
            enabled: false,
            param: "bnet-gdpr-test"
        }
    }

    function GDPR(scope) {
        "use strict";

        if (_config.enabled || (_config.testing.enabled && utilities.getParameter(document.URL, _config.testing.param) == "true")) {
            ;
            location.isCookieLawZone(function () {
                ;
                $('*[data-' + _config.dataattr + ']', scope).each(function (idx, elem) {
                    var filterVals = $(elem).data(_config.dataattr);
                    if (filterVals) {
                        var filters = filterVals.split('|');
                        _applyFilters(elem, filters);
                    }
                });
            }, function () {
                ;
            });
        } else {
            ;
        }
    }

    function _applyFilters(elem, filters) {
        // Checkbox
        if ($(elem).is(':checkbox')) {
            _applyCheckbox(elem, filters);
        }

        // Defaults
        _applyDefault(elem, filters);
    }

    var _checkboxFilters = ['checked', 'unchecked'];
    function _applyCheckbox(elem, filters) {
        ;
        for (var i = 0; i < filters.length; i++) {
            switch (filters[i]) {
                case 'checked':
                    ;
                    $(elem).prop('checked', true);
                    break;
                case 'unchecked':
                    ;
                    $(elem).prop('checked', false);
                    break;                    
            }
        }
    }

    var _defaultFilters = ['show', 'hide'];
    function _applyDefault(elem, filters) {
        ;
        for (var i = 0; i < filters.length; i++) {
            switch (filters[i]) {
                case 'show':
                    ;
                    $(elem).show();
                    $(elem).removeClass('hidden');
                    break;
                case 'hide':
                    ;
                    $(elem).hide();
                    break;
            }
        }
    }

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            ;
            return new GDPR(args.scope);
        }
    }
});
